import { Component, forwardRef } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DatePipe, NgClass, NgFor, NgIf, SlicePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonPipesModule } from '../pipes/common-pipes.module';
import { ImageZoomComponent } from './image-zoom/image-zoom.component';
import { AdvancedImageUploaderComponent } from './advanced-image-uploader/advanced-image-uploader.component';
import { BaseImageUploader } from './base-image-uploader.component';

declare const event: any;

@Component({
    selector: 'app-image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.scss'],
    imports: [
      DatePipe,
      MatProgressSpinnerModule,
      NgIf,
      NgFor,
      SlicePipe,
      NgClass,
      MatTooltipModule,
      CommonPipesModule,
      ImageZoomComponent,
      forwardRef(() => AdvancedImageUploaderComponent),
    ]
})
export class ImageUploaderComponent extends BaseImageUploader {
 
}
